// src/modules/app-views/welcome/pages/Init/modals/FirstSubscriptionModal/StepOperators.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Alert } from 'antd';
import { TfiWorld } from 'react-icons/tfi';
import OperatorsCard from 'modules/app-views/account/pages/Subscription/tabs/RecordTab/OperatorsCard';
import translateX from 'utils/translateX';
import app from 'configs/appResolver';

// *******************************************************************************
// STEP CONTENT COMPONENT
// *******************************************************************************
const StepOperatorsContent = ({ state, setState }) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 6. HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────
  const handleOperatorsChange = operatorActiveIds => {
    setState(prev => ({ ...prev, operatorActiveIds }));
  };

  const handleOperatorsLoad = replicatedIds => {
    setState(prev => ({
      ...prev,
      operatorActiveIds: prev.operatorActiveIds || replicatedIds,
      operatorReplicatedIds: replicatedIds,
    }));
  };

  // ─────────────────────────────────────────────────────────────────────────────
  // 9. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <div style={{ paddingTop: 8 }}>
      {/* Info message */}
      <Alert
        type="info"
        showIcon
        icon={<TfiWorld />}
        style={{ marginBottom: 16 }}
        title={translateX('operators')}
        description={translateX('select_operators_description')}
      />

      {/* Operators selection */}
      <OperatorsCard
        value={state.operatorActiveIds || []}
        onChange={handleOperatorsChange}
        onLoad={handleOperatorsLoad}
      />
    </div>
  );
};

// *******************************************************************************
// STEP CONFIGURATION
// *******************************************************************************
const stepOperators = ({ state, setState }) => ({
  stepTitle: 'operators',
  stepTooltip: 'select_operators',
  hidden: !app.MODULES?.includes('appmultiOperators'),
  content: () => <StepOperatorsContent state={state} setState={setState} />,
});

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default stepOperators;
